var __vueify_insert__ = require("vueify/lib/insert-css")
var __vueify_style__ = __vueify_insert__.insert(".bucks-back-login-button a[data-v-6]{text-decoration:none}")
;(function(){module.exports = {
  mixins: [require('../../../shared/frontend/vue/vue-mixins')],
  props: ['redirectUrl', 'loggedIn', 'hasCCookie', 'cssClass', 'isTouchRequest'],
  inheritAttrs: false,
  computed: {
    attrs: function() {
      if (!this.loggedIn && !this.hasCCookie) {
        return {
          bhw: 'BucksBackSignUpButton',
          buttonTextKey: 'js.modules.rewards.common.sign_up_text',
          redirectUrl: this.redirectUrl || this.t('js.modules.rewards.common.sign_up_url')
        };
      }
      if (!this.loggedIn && this.hasCCookie) {
        return {
          bhw: 'BucksBackLoginButton',
          buttonTextKey: 'js.modules.rewards.common.sign_in',
          redirectUrl: this.redirectUrl || this.t('js.modules.rewards.common.sign_in_url')
        };
      }
    }
  },
  methods: {
    click: function() {
      var el;
      if (!this.isTouchRequest) {
        el = GIG.Modal.currentOpenModal();
        if (el) {
          return $('body').one('click', '#login-modal a.close-modal, #login-modal', function() {
            return GIG.Modal.open({
              el: el
            });
          });
        }
      } else {
        return this.redirect(this.attrs.redirectUrl);
      }
    }
  },
  components: {
    IframeLoginModal: require('../../../shared/frontend/components/iframe-login-modal.vue')
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
__vue__options__.render = function(){with(this){return (!loggedIn)?_c('div',{staticClass:"bucks-back-login-button",attrs:{"data-bhw":"BucksBackLogin"}},[_c('a',{staticClass:"btn-cta t-button",class:cssClass,attrs:{"href":attrs.redirectUrl,"data-login-required":"true","data-bhw":attrs.bhw},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();click($event)}}},[_t("default",[_c('span',[_v(_s(t(attrs.buttonTextKey)))])])],2),_v(" "),(!isTouchRequest)?_c('iframe-login-modal',{attrs:{"logged-in":loggedIn,"has-c-cookie":hasCCookie}}):_e()],1):_e()}}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-6"
